import { render, staticRenderFns } from "./MyGradeInfo.vue?vue&type=template&id=70372f58&"
import script from "./MyGradeInfo.vue?vue&type=script&lang=js&"
export * from "./MyGradeInfo.vue?vue&type=script&lang=js&"
import style0 from "./MyGradeInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports